import { saveAuthSession } from '@/utils/profile/authSession';
import { sendOtp, validateOtp } from '@/utils/profile/login-register/api';
import { useErrorStore } from '@/stores/profile/errorStore';
import { notifyLandingRegister } from '@/utils/profile/landing-register/notifyLandingRegister';

// Function to handle sending OTP
export const handleSendOtp = async (
    phone: string,
    setPhone: (phone: string) => void,
    setStep: (step: number) => void,
    setLoading: (loading: boolean) => void,
    landingSlug?: string,
    httpReferrer?: string,
): Promise<{ success: boolean; message: string }> => {
    const { setError, setSuccess } = useErrorStore.getState();
    setLoading(true);

    try {
        const data = await sendOtp(phone, landingSlug, httpReferrer);
        if (data.success) {
            setPhone(phone);
            setSuccess(data.message);
            setStep(2);
            setError(null);
            return { success: true, message: data.message };
        } else {
            setError(data.message);
            return { success: false, message: data.message || 'خطا در ارسال کد تایید' };
        }
    } catch (error: any) {
        const message = error?.data?.message || 'خطا در ارتباط با سرور';
        setError(message);
        return { success: false, message };
    } finally {
        setLoading(false);
    }
};
// Function to handle OTP verification
export const handleVerifyOtp = async (
    phone: string,
    otp: string,
    setToken: (token: string) => void,
    setLoading: (loading: boolean) => void,
    landingSlug?: string,
    httpReferrer?: string,
): Promise<{ token: string; success: boolean; message: string }> => {
    const { setError } = useErrorStore.getState();
    setLoading(true);
    try {
        const response = await validateOtp(phone, otp, landingSlug, httpReferrer);
        const token = response.data?.token?.token; // Extract the token from the response
        if (token) {
            setToken(token); // Store the token in state
            // Shared with Sheba and Tether web (.khanesarmaye.com); the refresh token renews the session after 7 days.
            saveAuthSession(token, response.data?.refresh?.token);

            if (landingSlug) {
                await notifyLandingRegister(phone, token, landingSlug, httpReferrer);
            }
            return { token: token, success: true, message: response.message };
        } else {
            setError(response.message);
            return {
                token: '',
                success: false,
                message: response.message || 'خطا در ارسال کد تایید',
            };
        }
    } catch (error: any) {
        const message = error?.error || 'خطا در ارتباط با سرور';
        setError(message);
        return { token: ' ', success: false, message };
    } finally {
        setLoading(false);
    }
};
